export default "__VITE_ASSET__CQLbuTo$__"